import createTheme from '@/themes/createTheme.ts'

const theme = {
  mainColor: '#14655B', // 主题色 #13655B 绿色
  visionColor: '#f9f0ff', // 主题 衍生色  按钮背景  hover等效果
  rowSelectedHoverBg: '#efdbff', // 主题 衍生色  按钮背景  hover等效果
  headerIconBorder: '#d3adf7', //  导航图标边框
  headerIconBg: '#9254de', //  导航图标背景
}

export default createTheme(theme)
